import './styles/globals.css'
import {Routing} from 'routing'
import {StoreProvider, stores} from 'rest/stores'
import {useEffect} from 'react'
import {AuthService} from 'rest'
import {DndProvider} from 'react-dnd'
import {HTML5Backend} from 'react-dnd-html5-backend'
import {useSiteMeta} from 'hooks/useSiteMeta'

export const App = () => {
  useSiteMeta()

  useEffect(() => {
    AuthService.getAuthUser()
  }, [])

  return (
    <StoreProvider value={stores}>
      <DndProvider backend={HTML5Backend}>
        <Routing />
      </DndProvider>
    </StoreProvider>
  )
}
